export default __webpack_public_path__ + "static/progresar-b6cb0b5f7c6f828954f8861bb15fde5b.jpg";